import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchOrden, editOrden } from "../../actions/ordenesActions";
import Modal from 'react-bootstrap/Modal';
import { fetchPlanesPorParametros } from "../../actions/planesActions";
import { fetchTiposAdquirientes } from '../../actions/tiposActions';
import { toast } from "react-toastify";
import { customStyle } from '../../template/CustomStyle';
import { DropDownArrow } from "../../template/CustomStyle";
import Select from 'react-select';

class MedioDePago extends Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            show: false,
            modalData: {
                nroPlan: "",
                montoCuota: "",
                recargo: "",
                idTransaccion: "",
                primerosSeisDigitos: "",
                ultimosCuatroDigitos: "",
                nroCupon: "",
                idAdquiriente: ""
            }
        }
    }

    componentDidUpdate = prevProps => {
        // this.props.fetchOrden(this.props.id);
    }

    componentWillReceiveProps = prevProps => {
        if (this.didEdit) {
            this.props.fetchOrden(this.props.idOrden);
            this.setState({
                didEdit: false
            })
        }
    }

    removePago = (e) => {
        e.preventDefault();
        this.props.orden.pago.splice(e.target.name, 1);
        this.forceUpdate();
    }

    handleClose = (e) => {
        if (e != null) e.preventDefault();
        this.setState({ show: false });
    }

    handleShow = (e) => {
        if (e != null) e.preventDefault();
        this.setState({ show: true });
    }

    openModalAgregar = (e) => {
        e.preventDefault();
        this.setState({
            show: true, modalData: {
                nroPlan: "",
                montoCuota: "",
                recargo: "",
                idTransaccion: "",
                primerosSeisDigitos: "",
                ultimosCuatroDigitos: "",
                nroCupon:""
            }
        })
    }

    inputPago = (e) => {
        if (e.target.name == "nroPlan" && e.target.value != 0) {
            e.target.value.trim();
            this.busquedaPlanPorNro(e.target.value);
        }
        let notRequiredValues = false;
        if ((e.target.name == "nroCupon" && e.target.value >= 0 && e.target.value.length >= 0) ||
            (e.target.name == "primerosSeisDigitos" && e.target.value.length <= 6 && e.target.value.length >= 0 && e.target.value >= 0) ||
            (e.target.name == "ultimosCuatroDigitos" && e.target.value.length <= 4 && e.target.value.length >= 0 && e.target.value >= 0) ||
            (e.target.name == "idTransaccion" && e.target.value.length >= 0 && e.target.value >= 0) ||
            (e.target.name == "recargo" && e.target.value.length >= 0 && e.target.value >= 0)) {
            this.setState({ modalData: { ...this.state.modalData, [e.target.name]: e.target.value } })
        }
        if ((e.target.name == "montoCuota" && e.target.value.length >= 0 && e.target.value >= 0) ||
            (e.target.name == "nroPlan" && e.target.value >= 0) ||
            (e.target.name == "idAdquiriente" && e.target.value >= 0)) {
            this.setState({ modalData: { ...this.state.modalData, [e.target.name]: e.target.value } })
        }
    }

    busquedaPlanPorNro = (nro) => {
        if (nro) {
            this.props.fetchPlanesPorParametros({ 
                "Numero": nro, 
                "CantidadPagina": 10, 
                "NumeroPagina": 1, 
                "IdPlataforma": 1 
            });
        } else {
            this.props.fetchPlanesPorParametros({ 
                "Numero": 0, 
                "CantidadPagina": 10, 
                "NumeroPagina": 1, 
                "IdPlataforma": 1 
            });
        }
    }

    agregarPago = (e) => {
        e.preventDefault();
        let valido = this.validarModalData();
        if (!valido) {
            return toast.error("Valores incompletos o Nro plan inexistente");
        }
        let length = this.props.orden.pago.length;
        let i = length;
        this.props.orden.pago.push({
            "nroPlan": 0,
            "montoCuota": 0,
            "recargo": 0,
            "IdTransaccion": 0,
            "primerosSeisDigitos": 0,
            "ultimosCuatroDigitos": 0,
            "nroCupon": 0,
            "idAdquiriente": 0
        });

        this.props.orden.pago[i] = this.state.modalData;
        this.forceUpdate();
        this.setState({ show: false });
    }

    validarModalData = () => {
        let valido = false;
        if ((this.state.modalData.nroCupon && this.state.modalData.nroCupon > 0) &&
            (this.state.modalData.recargo && this.state.modalData.recargo > 0) &&
            (this.state.modalData.idTransaccion && this.state.modalData.idTransaccion > 0) &&
            (this.state.modalData.primerosSeisDigitos && this.state.modalData.primerosSeisDigitos.length == 6) &&
            (this.state.modalData.ultimosCuatroDigitos && this.state.modalData.ultimosCuatroDigitos.length == 4) &&
            (this.state.modalData.nroPlan && this.props.planes.elementos != undefined) &&
            (this.state.modalData.montoCuota && this.state.modalData.montoCuota > 0) &&
            (this.state.modalData.idAdquiriente && this.state.modalData.idAdquiriente > 0 )) {
            valido = true;
        }
        if ((this.state.modalData.nroPlan && this.props.planes.elementos != undefined) &&
            (this.state.modalData.montoCuota && this.state.modalData.montoCuota > 0) &&
            (this.state.modalData.idAdquiriente && this.state.modalData.idAdquiriente > 0)) {
            valido = true;
            if ((this.state.modalData.primerosSeisDigitos.length>0 && this.state.modalData.primerosSeisDigitos.length < 6) ||
                (this.state.modalData.ultimosCuatroDigitos.length>0 && this.state.modalData.ultimosCuatroDigitos.length < 4)) {
                valido = false;
            }
        }
        
        return valido;
    }

    selectSearchHandler = (options) => {         
        this.setState({ modalData: { ...this.state.modalData, "idAdquiriente": options.value } })
    }

    onSelectSearchInputAdquirente = () => {
        this.props.fetchTiposAdquirientes();
    }

    render() {
        

        let datosDelPlan = null;
        let comision = null;
       
        if (this.props.tipoUsuario == 2) {
            datosDelPlan = this.props.orden.pago.cupones.map((item, index) => {
                return (
                    <div>
                        <div className="list-group-item hover-background-color" >
                            <div className="row">
                                <div className="col-md-3 col-lg-3">
                                    <small className=" font-14  applyFont"><label>Nro Plan: </label> {item.nroPlan}</small>
                                </div>
                                <div className="col-md-3 col-lg-3">
                                    <small className=" font-14  applyFont"><label>Cuotas: </label> {item.cuotas}</small>
                                </div>
                                <div className="col-md-3 col-lg-3">
                                    <small className=" font-14  applyFont"><label>Tarjeta: </label> {item.tarjeta}</small> 
                                </div>
                                <div className="col-md-3 col-lg-3">
                                    <small className=" font-14  applyFont"><label>Importe: </label> {"$" + item.montoCuota}</small> 
                                </div>
                                <div className="col-md-3 col-lg-3">
                                    <small className=" font-14  applyFont"><label>Banco: </label> {item.banco}</small>
                                </div>
                                <div className="col-md-3 col-lg-3">
                                    <small className=" font-14  applyFont"><label>Autorización: </label> {item.autorizacion != null ? "$" + item.autorizacion : ""}</small>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3 col-lg-3">
                                    <small className=" font-14  applyFont"><label>Nro Cupón: </label> {item.nroCupon}</small>
                                </div>
                                <div className="col-md-3 col-lg-3">
                                    <small className=" font-14  applyFont"><label>Ultimos 4 digitos: </label> {item.ultimosCuatroDigitos}</small>
                                </div>
                                <div className="col-md-3 col-lg-3">
                                    <small className=" font-14  applyFont"><label>Adquirente: </label> {item.adquiriente}</small>
                                </div>
                                <div className="col-md-3 col-lg-3">
                                    <small className=" font-14  applyFont"><label>ID Transacción: </label> {item.idTransaccion}</small>
                                </div>
                                <div className="col-md-3 col-lg-3">
                                    <small className=" font-14  applyFont"><label className="applyFont">BIN: </label> {item.primerosSeisDigitos}</small>
                                </div>
                            </div>
                        </div>
                        <br></br>
                        
                    </div>
                    )
            })
        }
        else {
            return(
            comision = <div className="row">
                <div className="col-md-12 col-lg-12">
                    <h6 className="box-title m-b-5 font-weight-bold" >Datos de la comisión </h6>
                    <div className="row">
                        <div className="col-md-6 col-lg-6 align-self-center">
                            <small small className=" font-14  applyFont"><label>Tipo publicación: </label>{this.props.orden.tipoPublicacion.tipo}</small>
                        </div>
                    </div>
                </div>
                <br></br>
                </div>
            )
        }
        //debugger;
        //if (this.props.tipoUsuario == 2) {
        //comision=<div>
        //            <div className="list-group-item hover-background-color">
        //                <div className="row">
        //                    <div className="col-md-12 col-lg-12">
        //                        <h6 className="box-title m-b-5 font-weight-bold" >Datos de la comisión </h6>
        //                        <div className="row">
        //                            <div className="col-md-6 col-lg-6 align-self-center">
        //                                <small className=" font-14  applyFont"><label >Tipo publicación: </label> {this.props.orden.tipoPublicacion.tipo} </small>
        //                            </div>
        //                            <div className="col-md-6 col-lg-6">
        //                                <small className=" font-14  applyFont"><label>Comisión: </label> {this.props.orden.tipoPublicacion.comision + "%"}</small>
        //                            </div>
        //                        </div>
        //                    </div>
        //                </div>
        //            </div>
        //            <br></br>
        //        </div>
        //} 
 

        //if (this.props.newOrden) {

        //    renderNew = this.props.orden.pago.map((item, index) => {

        //        let labelAdquirente = this.props.propTiposAdquirientes.filter(i=>i.id==this.props.orden.pago[index].idAdquiriente);                                

        //        if (this.props.orden.pago.length > 0) {
        //            return (
        //                <div className="row">
        //                    <div className="form-group col-lg-12">
        //                        <label style={{ paddingRight: "1em" }}>Pago {index + 1}</label>
        //                        <button onClick={this.removePago} style={{ marginRight: "1em" }} name={index} className="btn btn-sm btn-light waves-effect waves-light"><i className="fas fa-minus"></i></button>
        //                    </div>
        //                    <div className="form-group col-lg-4">
        //                        <label> Nro Plan </label>
        //                        <input type="number" className="form-control" value={this.props.orden.pago[index].nroPlan} name={"nroPlan-" + index} />
        //                    </div>
        //                    <div className="form-group col-lg-4">
        //                        <label> Monto Cuota </label>
        //                        <input type="number" className="form-control" value={this.props.orden.pago[index].montoCuota} name={"montoCuota-" + index} />
        //                    </div>
        //                    <div className="form-group col-lg-4">
        //                        <label>Adquiriente</label>
        //                        <input type="text" className="form-control" value={labelAdquirente[0].descripcion} name={"idAdquiriente-" + index} />
        //                    </div>
        //                    <div className="form-group col-lg-4" hidden={this.props.orden.pago[index].recargo == "" ? true : false} >
        //                        <label>Recargo </label>
        //                        <input type="number" className="form-control" value={this.props.orden.pago[index].recargo} name={"recargo-" + index} />
        //                    </div>
        //                    <div className="form-group col-lg-4" hidden={this.props.orden.pago[index].idTransaccion == "" ? true : false} >
        //                        <label>Id Transaccion</label>
        //                        <input type="number" className="form-control" value={this.props.orden.pago[index].idTransaccion} name={"idTransaccion-" + index} />
        //                    </div>
        //                    <div className="form-group col-lg-4" hidden={this.props.orden.pago[index].primerosSeisDigitos == "" ? true : false}>
        //                        <label>Primeros 6 digitos</label>
        //                        <input type="number" className="form-control" value={this.props.orden.pago[index].primerosSeisDigitos} name={"primerosSeisDigitos-" + index}/>
        //                    </div>
        //                    <div className="form-group col-lg-4" hidden={this.props.orden.pago[index].ultimosCuatroDigitos == "" ? true : false} >
        //                        <label>Ultimos 4 digitos</label>
        //                        <input type="number" className="form-control" value={this.props.orden.pago[index].ultimosCuatroDigitos} name={"ultimosCuatroDigitos-" + index}/>
        //                    </div>
        //                    <div className="form-group col-lg-4" hidden={this.props.orden.pago[index].nroCupon == "" ? true : false}>
        //                        <label>Nro Cupón</label>
        //                        <input type="number" className="form-control" value={this.props.orden.pago[index].nroCupon} name={"nroCupon-" + index}/>
        //                    </div>


        //                </div>);
        //        }

        //    })

        //}

        //let renderHtml = null;
        //let buttonAgregar = null;
        //if (this.props.tipoUsuario == 2 && !this.props.newOrden) {
        //    renderHtml = [datosDelPlan, comision];
        //} else if (this.props.tipoUsuario !== 2 && !this.props.newOrden){
        //    renderHtml = comision;
        //}else if (this.props.newOrden) {
        //    renderHtml = renderNew;
        //    buttonAgregar = <button onClick={this.openModalAgregar} className="btn background-rojo-megatone btn-sm ">Agregar</button>
        //}


        //let valAdquiriente=null;
        //let listaAdquiriente = [];

        //if (this.props.propTiposAdquirientes != undefined) {
        //    this.props.propTiposAdquirientes.map((item, index) => {
        //        if (this.state.modalData.idAdquiriente == item.id) {
        //            valAdquiriente = { label: item.descripcion, value: item.id }
        //        }
        //    })

        //    this.props.propTiposAdquirientes.map((item, index) => {
        //        listaAdquiriente.push({ label: item.descripcion, value: item.id })
        //    })
        //}
        
        //let selectAdquiriente = <Select
        //    name="idAdquiriente"
        //    value={valAdquiriente}
        //    options={listaAdquiriente}
        //    onChange={this.selectSearchHandler}
        //    onInputChange={this.onSelectSearchInputAdquirente}
        //    styles={customStyle}
        //    components={{ DropdownIndicator: () => DropDownArrow }}
        ///>
        
        
        //let dataNroPlan = null;
        //if (this.props.planes.length != 0) {
        //    if (this.props.planes.elementos != undefined) {
        //        dataNroPlan = this.props.planes.elementos.map((item) => {
        //            return <>
        //                <label>{item.descripcion}</label>
        //            </>
        //        })
        //    }
        //}
        
        //let modalCreate = <Modal show={this.state.show} onHide={this.handleClose}>
        //    <Modal.Body>
        //        <div className="form-group col-lg-12">
        //            <label> Nro Plan </label>
        //            <input type="number" className="form-control" value={this.state.modalData.nroPlan} name={"nroPlan"} onChange={this.inputPago} />
        //        </div>
        //        {this.props.planes.cantidadTotal != 0 ? dataNroPlan : <label style={{ color: "red" }}>Plan inexistente</label>}
        //        <div className="form-group col-lg-12">
        //            <label> Monto Cuota </label>
        //            <input type="number" className="form-control" value={this.state.modalData.montoCuota} name={"montoCuota"} onChange={this.inputPago} />
        //        </div>
        //        <div className="form-group col-lg-12">
        //            <label>Adquiriente</label>
        //            {selectAdquiriente}
        //        </div>
        //        <div className="form-group col-lg-12">
        //            <label>Recargo </label>
        //            <input type="number" className="form-control" value={this.state.modalData.recargo} name={"recargo"} onChange={this.inputPago} />
        //        </div>
        //        <div className="form-group col-lg-12">
        //            <label>Id Transaccion</label>
        //            <input type="number" className="form-control" value={this.state.modalData.idTransaccion} name={"idTransaccion"} onChange={this.inputPago} />
        //        </div>
        //        <div className="form-group col-lg-12">
        //            <label>Primeros 6 digitos</label>
        //            <input type="number" className="form-control" value={this.state.modalData.primerosSeisDigitos} name={"primerosSeisDigitos"} onChange={this.inputPago} />
        //        </div>
        //        <div className="form-group col-lg-12">
        //            <label>Ultimos 4 digitos</label>
        //            <input type="number" className="form-control" value={this.state.modalData.ultimosCuatroDigitos} name={"ultimosCuatroDigitos"} onChange={this.inputPago} />
        //        </div>
        //        <div className="form-group col-lg-12">
        //            <label>Nro Cupón</label>
        //            <input type="number" className="form-control" value={this.state.modalData.nroCupon} name={"nroCupon"} onChange={this.inputPago}/>
        //        </div>
                

        //    </Modal.Body>
        //    <Modal.Footer>

        //        <button className="btn background-rojo-megatone btn-sm " onClick={this.agregarPago}>
        //            Agregar
        //    </button>
        //        <button className="btn btn-grey btn-sm" onClick={this.handleClose}>
        //            Cerrar
        //    </button>
        //    </Modal.Footer>
        //</Modal>


        return (
            <div className="tab-pane p-20 active " name="datos" id="home2" role="tabpanel">
                {datosDelPlan}
                {comision}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    orden: state.ordenes.orden,
    tipoUsuario: state.general.tipoUsuario,
    planes: state.planes.planesPorParametros,
    propTiposAdquirientes: state.tipos.adquirientes
});
export default connect(mapStateToProps, { 
    fetchTiposAdquirientes,
    fetchOrden, 
    editOrden, 
    fetchPlanesPorParametros
})(MedioDePago);